/**
 * @overview 预约 新增/编辑
 * @author jzhu
 * @date 2020-8-14
 */

import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
let { WizContainer, modelUtils } = framework_tool
let { WizCard, WizForm, WizSpin, WizRow, WizCol, WizButton, WizModal } = component_tool
let { Session, Storage, dateUtils } = utils_tool
import { createColumns } from './columns'

const getParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/site/trainSite/appointment/management/appointmentAdd') {
        if (history.location.record) {
            let { id, name, code, type, auditType } = history.location.record
            record = {
                siteId: id,
                name,
                code,
                type,
                auditType
            }
            Session.set('appointmentAdd', record)
        } else {
            record = Session.get('appointmentAdd') || {}
        }
        let user = Storage.getStorage('user') || {}
        record.orderPersonId = user.personId
        record.fullName = user.fullName
        record.orderMobile = user.mobile
    }
    return record
}

class SiteOrderDetail extends WizContainer {

    componentName = 'SiteOrderDetail'

    constructor(props) {
        super(props)
        let { history } = props
        let record = getParamRecord(history)
        this.state = {
            record
        }
    }

    propsAndStateOnChange = {
        save: this._saveOnChange.bind(this)
    }

    _saveOnChange(nextProps, nextState) {
        if (nextProps.save.code === 1) {
            wizNotice.success('操作成功')
            this.jumpPage('push', '/site/trainSite/appointment/appointmentRecord')
        } else {
            wizNotice.error(nextProps.save.msg || '操作失败,请稍后尝试')
        }
        return true
    }

    _renderFooter = () => {
        return (
            <WizRow className='form-btns col-item'>
                <WizCol span={24}>
                    <WizButton title='保存' icon='check' type='primary' htmlType='submit'>保存</WizButton>
                    <WizButton title='重置' icon='reload' onClick={e => this._onReset()}>重置</WizButton>
                </WizCol>
            </WizRow>
        )
    }

    _onSubmit = (values) => {
        const record = this.state.record;
        
        const tmp = () => {
            let { date, ...rest } = values
            let start = dateUtils.formatDate(date.start, 'yyyy-MM-dd') + ' 00:00:00'
            let end = dateUtils.formatDate(date.end, 'yyyy-MM-dd') + ' 23:59:59'
            let apiParams = { ...rest, start, end }
            apiParams.status = 0 //预约状态 提交审核中
            this.doAction({
                path: 'siteOrder/create',
                payload: {
                    key: 'create_siteOrder',
                    apiParams: apiParams
                }
            })
        }
        
        if(record.type === 0 && record.auditType === 1) {
            WizModal.confirm({
                title: '该教室预定需要教室管理人员进行审核，是否需要继续提交?',
                onOk: () => {
                    tmp();
                },
                onCancel() {}
            })
        } else {
            tmp();
        }
        
    }

    _onReset = () => {

    }

    _render() {
        let formProps = {
            ref: 'form',
            columns: createColumns(this, this.state.record),
            record: this.state.record,
            onSubmit: this._onSubmit,
            footer: this._renderFooter(),
            formItemLayout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 17 }
            }
        }
        return (
            <WizCard>
                <WizSpin tip={'加载中'} spinning={this.props.siteOrderLoading}>
                    <WizForm className={'form-inline'} {...formProps} />
                </WizSpin>
            </WizCard>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let { siteOrder } = state
    const save = modelUtils.getModelEntity(siteOrder, 'create_siteOrder')
    const load = modelUtils.getLoadingState(state, 'siteOrder')
    return {
        save,
        ...load
    }
}

export default connect(mapStateToProps)(SiteOrderDetail)
